import React from 'react';
import ourfeature1 from "./images/ourFeature1.webp";
import ourfeature2 from "./images/ourfeaturetw.webp";
import ourfeature3 from "./images/ourfeature3.webp";
const OurFeature = () => {
  return (
    <section className="text-center py-5">
      <h6 className="text-uppercase text-muted">Highlights</h6>
      <h2 className="fw-bold mb-3">Seamless Collaboration & Workflow Optimization with TOODHU   </h2>
      <p className="variertytxt">
Boost teamwork, secure data, and make informed decisions using Toodhu’s powerful business management software. Improve productivity with small business management software features designed to streamline operations.       </p>

      <div className="container">
        <div className="row">
          {features.map((feature, index) => (
            <div className="col-md-4 mb-4 collpartionimg" key={index}>
              <div className="">
                <img src={feature.image} alt={feature.title} className="img-fluid mb-4"  id='ourfeatureimg'/>
                <h5 className="collpartiontitle">{feature.title}</h5>
                <p className="collpartionpara">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const features = [
  {
    title: 'Collaboration Teams',
    description: 'Improve teamwork with seamless communication and task management, enabling smooth coordination across departments and partners.',
    image: ourfeature1,
  },
  {
    title: 'Cloud Storage',
    description: 'Store, manage, and access data securely from anywhere, ensuring reliability, scalability, and effortless collaboration.',
    image: ourfeature2,
  },
  {
    title: 'Daily Analytics',
    description: 'Track performance with real-time insights, monitor key metrics, and make data-driven decisions for business growth.',
    image: ourfeature3,
  },
];

export default OurFeature;
